import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './Content.module.css';

const Content = ({ children, slug }) => {
  return (
    <section
      className={`${classes.content} ${
        slug === 'terms-and-conditions' || slug === 'osto-ja-varausehdot'
          ? classes.terms
          : ''
      }`}
    >
      {children}
    </section>
  );
};

Content.propTypes = {
  children: PropTypes.array.isRequired,
  slug: PropTypes.string,
};

export default Content;
